import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var AddOrEditItemsIA = function AddOrEditItemsIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "7fDMID",
      defaultMessage: [{
        "type": 0,
        "value": "Ga eerst naar de "
      }, {
        "children": [{
          "type": 0,
          "value": "pagina met bestelgegevens"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": " om producten aan een bestelling toe te voegen of te bewerken. Selecteer vervolgens Bestelling "
      }, {
        "children": [{
          "type": 0,
          "value": "bewerken"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ab3w4/",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt producten toevoegen door op de knop "
      }, {
        "children": [{
          "type": 0,
          "value": "Product toevoegen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te klikken en ze verwijderen door op het prullenbak-pictogram naast elk artikel te klikken. Je kunt artikelhoeveelheden bijwerken door het nummer in de kolom "
      }, {
        "children": [{
          "type": 0,
          "value": "Aantal"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te wijzigen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "UjBG6x",
      defaultMessage: [{
        "type": 0,
        "value": "Nadat je je bewerkingen hebt uitgevoerd, klik je op "
      }, {
        "children": [{
          "type": 0,
          "value": "Bijwerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " om ze op te slaan. Je hebt ook de mogelijkheid om een bericht achter te laten voor de retailer, wat we erg aanbevelen. Op die manier weet de retailer wat er met de bestelling gebeurt. De retailer ontvangt een e-mail met de wijzigingen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Sdx3lz",
      defaultMessage: [{
        "type": 0,
        "value": "Om producten aan een bestelling toe te voegen of te bewerken, ga je eerst naar je pagina "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " en ga je naar de pagina "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingsgegevens"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " voor de bestelling die je wilt wijzigen. Klik vervolgens op "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestelling bewerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Un5qc8",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt producten toevoegen door op de knop "
      }, {
        "children": [{
          "type": 0,
          "value": "Product toevoegen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te klikken en ze verwijderen door op het prullenbak-pictogram naast elk artikel te klikken. Je kunt artikelhoeveelheden bijwerken door het nummer in de kolom "
      }, {
        "children": [{
          "type": 0,
          "value": "Aantal"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te wijzigen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lyNjZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Nadat je je bewerkingen hebt uitgevoerd, klik je op "
      }, {
        "children": [{
          "type": 0,
          "value": "Bijwerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " om ze op te slaan. Je hebt ook de mogelijkheid om een bericht achter te laten voor de retailer, wat we erg aanbevelen. Op die manier weet de retailer wat er met de bestelling gebeurt. De retailer ontvangt een e-mail met de wijzigingen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};